import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import NoItemResult from '../../../../../components/results/NoItemResult';
import { type PermissionValues } from '../../../../../utilities/hasPermissions';

export type AudiCalculationSettingsEmptyListProps = {
    openAudiCalculationSettingDrawer: () => void;
    permissions: Pick<PermissionValues, 'hasUpdatePermission'>;
};

const AudiCalculationSettingsEmptyList = ({
    openAudiCalculationSettingDrawer,
    permissions,
}: AudiCalculationSettingsEmptyListProps) => {
    const { t } = useTranslation(['audiCalculationModuleDetails']);
    const { hasUpdatePermission } = permissions;

    return (
        <NoItemResult
            extra={
                hasUpdatePermission && (
                    <Button htmlType="button" loading={false} onClick={openAudiCalculationSettingDrawer} type="primary">
                        {t('audiCalculationModuleDetails:settings.noData.action')}
                    </Button>
                )
            }
            subTitle={t('audiCalculationModuleDetails:settings.noData.message')}
        />
    );
};

export default AudiCalculationSettingsEmptyList;
